import { api } from '../client';

export enum ScanResultType {
  INVENTORY_ITEM = 'INVENTORY_ITEM',
  EQUIPMENT = 'EQUIPMENT',
  BATCH = 'BATCH',
  NOT_FOUND = 'NOT_FOUND',
}

export interface InventoryItemScanResult {
  id: string;
  sku: string;
  name: string;
  description: string | null;
  category: string;
  barcode: string | null;
  unitCost: number | null;
  unit: string;
  levels: {
    locationId: string;
    locationName: string;
    locationCode: string;
    quantity: number;
    availableQty: number;
  }[];
  totalStock: number;
}

export interface EquipmentScanResult {
  id: string;
  assetNumber: string;
  name: string;
  description: string | null;
  category: string;
  status: string;
  condition: string;
  serialNumber: string | null;
  manufacturer: string | null;
  model: string | null;
  locationId: string;
  locationName: string;
  nextServiceDate: string | null;
}

export interface BatchScanResult {
  id: string;
  batchNumber: string;
  itemId: string;
  itemName: string;
  itemSku: string;
  quantity: number;
  status: string;
  expiryDate: string | null;
  locationId: string;
  locationName: string;
}

export interface ScanResult {
  type: ScanResultType;
  inventoryItem?: InventoryItemScanResult;
  equipment?: EquipmentScanResult;
  batch?: BatchScanResult;
  message?: string;
}

export interface BulkScanResult {
  results: ScanResult[];
  totalScanned: number;
  found: number;
  notFound: number;
}

export const barcodeApi = {
  scan: (code: string) =>
    api.get<ScanResult>(`/api/barcode/scan/${encodeURIComponent(code)}`),

  bulkScan: (barcodes: string[]) =>
    api.post<BulkScanResult>('/api/barcode/bulk-scan', { barcodes }),

  generateBarcode: (itemId: string, barcodeType?: string, customBarcode?: string) =>
    api.post<{ barcode: string; barcodeType: string }>('/api/barcode/generate', {
      itemId,
      barcodeType,
      customBarcode,
    }),

  getItemBarcode: (itemId: string) =>
    api.get<{ barcode: string | null; barcodeType: string | null }>(`/api/barcode/item/${itemId}`),

  updateBarcode: (itemId: string, barcode: string, barcodeType?: string) =>
    api.patch(`/api/barcode/item/${itemId}`, { barcode, barcodeType }),
};

export default barcodeApi;
